export const SLOT_CLUBS_PROMOTIONS = 'slot-clubs-promotions';

export enum SLOT_CLUBS_PROMO_ACTIONS {
    gameLaunch = 'gameLaunch',
    internalLink = 'internalLink',
    externalLink = 'externalLink',
    atpLaunch = 'atpLaunch',
}
